export default __webpack_public_path__ + "static/media/usd.e2eef164.svg";